import * as React from "react";
import { Row } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { GroupSelect } from "Components/General/GroupSelect";
import { filePrintStore } from "../FilePrintStore";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { contactsStore } from "Stores/ContactsStore";

interface AddGroupProps extends WithTranslation, ModalComponentProps {
  addNewContactsGroup: (values: {}) => Promise<void>;
}

export const AddGroup = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<AddGroupProps> {
      handleAddGroup = async (groupId: number) => {
        try {
          const members: API_GroupMember[] = await filePrintStore.getGroupMembers(groupId);

          this.props.addNewContactsGroup(
            members.map((member) =>
              member.contact
                ? contactsStore.globalUserContacts.find((c) => c.id === member.id)
                : contactsStore.projectUsers.find((u) => u.id === member.id)
            )
          );
          this.props.hideModal();
        } catch (error) {
          throw error;
        }
      };

      render() {
        const { t } = this.props;

        return (
          <>
            <h1>{t("Choose user group")}</h1>
            <Row align="middle" gutter={24}>
              <GroupSelect groupType="FOR_MAIL" onSelect={this.handleAddGroup} style={{ width: "100%" }} />
            </Row>
          </>
        );
      }
    }
  )
);
